<div class="top-section">
    <h6 class="heading mb-0">{{ ss.t('features_titleTopBar') }}</h6>
    <div class="">
        <app-svg name="close" role="button" (click)="closeDialog()"></app-svg>
    </div>
</div>

<div class="body-section feature-block position-relative">
    <div class="feature-data flex items-start ri-px-4 ri-py-2"
        *ngFor="let feature of featureStore.premiumFeatures(); let i = index;" role="button"
        (click)="addFeature(feature)">
        <app-svg class="ri-mt-2px" [ngClass]="feature.mirrorRtl ? 'icon-mirror-rtl' : ''" [name]="feature.icon"
            [color]="ss.theme().color35"></app-svg>
        <div class="content w-full flex justify-between ri-ps-3">
            <div class="ri-pe-3">
                <p class="text-16-500 color-8 ri-pb-1 mb-0">{{ feature.title }}</p>
                <p class="text-14-400 color-7 mb-0 ri-pb-1 mb-0">{{ feature.description }}</p>
            </div>
            <div class="flex items-center">
                <app-svg name="plus" [color]="ss.theme().color35" style="width: 12px; height: 12px;" width="12px"
                    height="12px"></app-svg>
            </div>
        </div>
    </div>
</div>